import { colors, fonts } from 'components/styles/variables';
import { makeStyles } from '@material-ui/styles';
import { theme } from 'components/Shared/ThemeProviderWrapper';

export const useStyles = makeStyles({
  dialog: {
    height: 'auto',
    width: '456px',
    padding: '26px 16px 32px 16px',
    borderRadius: '16px',
    [theme.breakpoints.down('sm')]: {
      padding: 0,
      height: '100%',
      width: '100%',
      borderRadius: '0px',
    },
  },

  monthlyPaymentDialog: {
    height: 'auto',
    width: '435px',
    padding: '45px 35px 35px 35px',
    borderRadius: '5px',
    overflow: 'hidden',
    [theme.breakpoints.down('sm')]: {
      height: '100%',
      width: '100%',
      borderRadius: '0px',
    },
  },

  fixedHeight: {
    minHeight: '1700px',
    width: '100%',
  },

  fullWidth: {
    width: '100%',
  },

  noResults: {
    width: '100%',
    minHeight: '300px',
  },

  resultsList: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: colors.WHITE,
    justifyContent: 'start',
    fontFamily: fonts.default,
    alignItems: 'center',
    [theme.breakpoints.up('sm')]: {
      gap: 24,
    },
  },

  searchResultSpacer: {
    borderBottom: `1px ${colors.G2} solid`,
    width: '90%',
    height: '1px',
    [theme.breakpoints.up('sm')]: {
      display: 'none',
    },
  },

  item: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },

  desktopInlineAad: {
    marginTop: '24px',
  },

  mobileInlineAad: {
    marginTop: '12px',
  },

  pagination: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: 40,
  },
});
